import { BaseComponent, EventHandler, Manipulator, SelectorEngine } from './custom-core.js';
import Modal from './src/modal.js';
import Offcanvas from './src/offcanvas.js';

// Globális névhez hozzárendelés (iife miatt)
window.bootstrap = { Modal, Offcanvas };

// Automatikus inicializálás
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bs-toggle="modal"]').forEach(el => new Modal(el));
  document.querySelectorAll('[data-bs-toggle="offcanvas"]').forEach(el => new Offcanvas(el));
});